import React from 'react';
import s from './styles/FullScreenLoader.module.scss';

import loaderImg from '../../assets/loader/kandor-logo-loader.png';
import spinnerImg from '../../assets/loader/kandor-logo-spinner.png';
import textImg from '../../assets/loader/kandor-logo-text.png';

export function FullScreenLoader({ variant = 'fixed', className = '' }) {
  const rootClassName = [
    s.loader,
    variant === 'absolute' ? s.loader_absolute : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClassName} role="status" aria-label="Loading">
      <div className={s.loader__wrap}>
        <div className={s.loader__inner}>
          <div className={s.loader__logo}>
            <img alt="Kandor logo" src={loaderImg} />
            <div className={s.loader__spinner}>
              <img alt="Kandor spinner" src={spinnerImg} />
            </div>
          </div>

          <div className={s.loader__text}>
            <img alt="Kandor text" src={textImg} />
          </div>
        </div>

        <div className={s.dots} />
      </div>
    </div>
  );
}
